<template>
    <CompassDialog
        :visible.sync="showModal"
        size="small"
        :title="$t.__('popups.CashflowPopupWarning.try_cash_module')"
        @closed="close"
    >
        <template slot="default">
            <div class="dialog__default">
                <div class="cashflow-popup-warning__wrapper">
                    <CompassAlert
                        type="warning"
                        :description="content.alert"
                        showIcon
                        :action="null"
                        :showClose="false"
                    />
                    <span
                        class="typographies-paragraph-medium-regular"
                        v-html="content.description"
                    />
                </div>
            </div>
        </template>
        <template slot="footer">
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.close')"
                    type="secondary"
                    size="medium"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('popups.CashflowPopupWarning.contact_support')"
                    type="primary"
                    size="medium"
                    class="ml-3"
                    :disabled="false"
                    @click="contactSuport()"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    data() {
        return {
            showModal: true,
            content: {
                alert: this.$l10n.__(
                    'Le module facturation ou achats n’est pas inclut dans votre licence.',
                ),
                description: this.$l10n.__(
                    'Votre licence n’inclut pas le module facturation ou achats nécessaire au bon fonctionnement du module trésorerie. Rapprochez-vous d’un administrateur disposant de la licence %(br)s “Suite Sellsy” ou “Facturation & Gestion”.',
                    { br: '<br />' },
                ),
            },
        };
    },
    methods: {
        contactSuport() {
            // eslint-disable-next-line no-undef
            MySupport.getForm();
            this.close();
        },

        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.cashflow-popup-warning {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
